import { headers, API_BASE_URL } from './apiClient'

export async function login(username, password) {
  const response = await fetch(`${API_BASE_URL}/v1/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  })
  const data = await response.json()
  if (!response.ok) {
    throw new Error(data.error || "Erreur de connexion.")
  }
  return data
}

export async function logout(refreshToken) {
  await fetch(`${API_BASE_URL}/v1/auth/logout`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify({ refresh: refreshToken }),
  })
}
